export enum StatusResult {
    DEFAULT = 1,
    SUCCESS = 2,
    ERROR = 3,
}